<template>
  <div id="app">
    <Navbar />

    <Section title="Who?" id="who" />
    <Section title="What?" id="what" />
    <Section title="Where?" id="where" />

    <div class="box">
      <b-button
        type="is-danger"
        size="is-large"
        v-on:click="confirmResetClues"
        expanded
      >
        Clear
      </b-button>
    </div>

    <footer>
      <small>Images from the game set are property of Hasbro.</small>
    </footer>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Section from './Section.vue';
import Navbar from './Navbar.vue';

export default {
  name: 'app',
  components: {
    Section,
    Navbar,
  },

  methods: {
    ...mapActions('aspects', ['resetNotes']),

    confirmResetClues() {
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to clear all notes?',
        onConfirm: () => this.resetClues(),
      });
    },

    resetClues() {
      this.resetNotes();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.$buefy.toast.open('All notes reset');
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}

@import '../assets/app.scss';
</style>
